// src/components/FundraisingGoalPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useAppContext } from "../context/AppContext";
// import "./FundraisingGoalPage.scss";

const FundraisingGoalPage = () => {
  const navigate = useNavigate();
//   const { setAppState } = useAppContext();

  const [fundraisingTarget, setFundraisingTarget] = useState("");
  const [tokenPrice, setTokenPrice] = useState("");

  const handleNext = () => {
    if (!fundraisingTarget || !tokenPrice) {
      alert("Please provide a target and token price.");
      return;
    }
    // setAppState((prev) => ({
    //   ...prev,
    //   fundraisingGoal: { fundraisingTarget, tokenPrice },
    // }));
    console.log("{ fundraisingTarget, tokenPrice }", { fundraisingTarget, tokenPrice });
    
    navigate("/campaign-creation");
  };

  const handleTargetChange = (value) => {
    setFundraisingTarget(value);
    setTokenPrice(value / 1000); // Example logic: token price = target / 1000 tokens.
  };

  return (
    <div className="fundraising-goal">
      <h2>Set Your Fundraising Goal</h2>
      <input
        type="number"
        placeholder="Total Amount to Raise"
        value={fundraisingTarget}
        onChange={(e) => handleTargetChange(e.target.value)}
      />
      <p>Token Price: {tokenPrice ? `${tokenPrice} ETH` : "Auto-calculated"}</p>
      <button onClick={handleNext}>Set Goal</button>
    </div>
  );
};

export default FundraisingGoalPage;
